<template>
    <div>

        <rkm-area
            no-margin-top
            title="Cotas cadastradas"
        >

            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="handleTodosClick"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedColumns"
                        value-field="key"
                    />
                </rkm-dropdown>
            </template>

            <rkm-table
                :fields="fields"
                :items="dados"
                :filter="filter"
                ref="Table"
                class="mt-3 table"
                responsive
            >

                <template slot="filters">
                    <rkm-row>
                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                placeholder="Digite para buscar"
                                v-model="filter"
                            >
                                <rkm-input-group-prepend slot="prepend">
                                    <rkm-input-group-text>Buscar</rkm-input-group-text>
                                </rkm-input-group-prepend>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-select
                                :options="data.form.anos"
                                show-default-option
                                default-option-text="Selecione o ano"
                                text-field="cotaAno"
                                v-model="model.cotaAno"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-select
                                :options="data.form.meses"
                                show-default-option
                                default-option-text="Selecione o mês"
                                text-field="descricao"
                                value-field="id"
                                v-model="model.cotaMes"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-0">
                            <rkm-button
                                :disabled="!filter && !model.cotaMes && !model.cotaAno"
                                @click="handleClearFilter"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </template>

                <template v-slot:cell(cota)="{ item }">
                    {{ formatQuantidade(item) }}
                </template>

                <template v-slot:cell(mes)="{ item }">
                    {{ getMes(item.periodo.start) }}
                </template>

                <template v-slot:cell(ano)="{ item }">
                    {{ getAno(item.periodo.start) }}
                </template>

                <template v-slot:cell(utilizada)="{ item }">
                    {{ getUtilizada(item) }}
                </template>

                <template v-slot:cell(distribuida)="{ item }">
                    {{ getCotaAtribuida(item) }}
                </template>

                <template v-slot:cell(aDistribuir)="{ item }">
                    {{ getCotaADistribuir(item) }}
                </template>

                <template v-slot:cell(saldo)="{ item }">
                    {{ getSaldo(item) }}
                </template>

                <template v-slot:cell(actions)="{ index, item }">

                    <rkm-button
                        :color="item.observacao ? 'dark' : 'secondary'"
                        small
                        v-rkm-popover.hover.left="{
                            title:'Observação',
                            html:true,
                            content: item.observacao ? item.observacao : 'Nenhuma observação informada.',
                        }"
                    >
                        <i class="fas fa-comment-alt"></i>

                    </rkm-button>

                    <rkm-button
                        @click="openUnidadeSolicitante(item.id, item)"
                        color="info"
                        small
                        title="Unidade Solicitante"
                    >
                        <rkm-icon icon="door-closed" />
                    </rkm-button>

                    <rkm-button
                        @click="openExame(item.id, item)"
                        color="warning"
                        class="colorButton"
                        small
                        title="Exames"
                    >
                        <rkm-icon icon="vial" />
                    </rkm-button>

                    <rkm-button
                        @click.stop="$emit('copyCota', item)"
                        color="success"
                        small
                        title="Replicar"
                    >
                        <rkm-icon icon="clone" />
                    </rkm-button>

                    <rkm-button
                        v-if="checkLaboratorio == true"
                        @click.stop="$emit('handleAlter', index, item)"
                        color="primary"
                        small
                        title="Editar"
                    >
                        <rkm-icon icon="pen" />
                    </rkm-button>

                    <rkm-button
                        color="danger"
                        title="Excluir"
                        small
                        @click.stop="handleCota(item)"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <modalExame
            :data="data"
            ref="modalExame"
            @save="save"
        />

        <modalUnidadeSolicitante
            :data="data"
            ref="modalUnidadeSolicitante"
            @save="save"
        />
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, data, formats } from '@/mixins'

// Components.
import modalExame from './exames/Modal'
import modalUnidadeSolicitante from './unidade-solicitante/Modal'

// Enums.
import tipoCota from '@/enums/exame-laboratorial/tipoCota'
import mesesAno from '@/enums/geral/mesesAno'

// Moment.
import moment from 'moment'

export default {
    components: { modalExame, modalUnidadeSolicitante },
    computed: {
        fields() {
            return this.columns.filter(column => (column.fixed || false) || this.selectedColumns.includes(column.key))
        },
        optionalColumns() {
            return this.columns.filter(column => !(column.fixed || false))
        },
        dados(){

            const ano = this.model.cotaAno
            const mes = this.model.cotaMes

            if (ano != null && mes != null) {

                return this.cotaLaboratorio.filter(i => {return i.periodo.start.substr(6, 4) == ano
                    && i.periodo.start.substr(3, 2) == mes})

            } else if ( ano != null) {

                return this.cotaLaboratorio.filter(i => {return i.periodo.start.substr(6, 4) == ano})

            } else if ( mes != null) {

                return this.cotaLaboratorio.filter(i => {return i.periodo.start.substr(3, 2) == mes})
            }

            return this.cotaLaboratorio
        },
    },
    data: () => ({
        items: [],
         model:{
            cotaAno: null,
            cotaMes: null,
        },
        filter: null,
        enums: {
            tipoCota,
            mesesAno
        },
        cotasAtribuidas: 0,
        cotaAtribuida: 0,
        saldoAtribuidas: null,
        utilizada: 0,
        utilizadas: 0,
        saldoUtilizadas: 0,
        selectedAll: false,
        indeterminate: false,
        columns: [
            { key: 'cotaTipoNome', label: 'Tipo', fixed: true, sortable: true },
            { key: 'cota', label: 'Cota', class: 'text-center', fixed: true, sortable: true },
            { key: 'distribuida', label: 'Distribuída', class: 'col-min text-center', sortable: true },
            { key: 'aDistribuir', label: 'A distribuir', class: 'col-min text-center', sortable: true },
            { key: 'utilizada', label: 'Utilizada', class: 'col-min text-center', sortable: true },
            { key: 'saldo', label: 'Saldo', class: 'text-center', fixed: true, sortable: true },
            { key: 'mes', label: 'Mês', class: 'text-center', fixed: true, sortable: true },
            { key: 'ano', label: 'Ano', class: 'text-center', fixed: true, sortable: true },
            { key: 'periodo.start', label: 'Inicio', class: 'text-center', fixed: true, sortable: true },
            { key: 'periodo.end', label: 'Fim', class: 'text-center', fixed: true, sortable: true },
            { key: 'actions', label: 'Ações', fixed: true, class: 'col-min' },
        ],
        selectedColumns: [],
    }),
    created() {

        this.repositories = {
            saldo: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }

        this.load()
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.cotaAno = this.cotaAno == null ? moment().format("YYYY") : this.cotaAno
        },
        handleTodosClick(selected) {
            this.selectedColumns = selected ? this.optionalColumns.map(c => c.key) : []
        },
        handleCota(item) {

            this.setLoading()

            this.repositories.saldo.saldoUnidadeSolicitante({
                unidade_id: this.unidadeId,
                infraestrutura_id: this.infraestruturaId,
                inicio: item.periodo.start.split("/").reverse().join("-"),
                fim: item.periodo.end.split("/").reverse().join("-"),
                cota_tipo_id: item.cotaTipoId,
            })
                .then(response => {

                    this.getCotaUtilizada(item, response.data)

                    if (this.utilizadas == 0 || this.utilizadas == '0,00') {

                        this.handleDestroy(item)
                    } else {

                        this.showValidationNotification(`Não é possível excluir a cota do período de
                            <strong>${ item.periodo.start }</strong> até <strong>${ item.periodo.end }</strong>, pois
                            já possui agendamentos vinculados a ela.`)

                        return false
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getCotaUtilizada(cotaExamePeriodo, items) {

            if (cotaExamePeriodo.cotaTipoId == this.enums.tipoCota.VALOR) {

                this.utilizadas = this.formatMoney(parseFloat(items.valorAgendado), 2)
            } else {

                this.utilizadas = items.quantidadeAgendada
            }
        },
        getUtilizada(item) {

            if (item.cotaTipoId == this.enums.tipoCota.VALOR) {

                return item.valorUtilizado
            } else {

                return Number(item.quantidadeUtilizada)
            }
        },
        getSaldo(item) {

            if (item.cotaTipoId == this.enums.tipoCota.VALOR) {

                let cota = this.formatMoney(item.cota, 2)
                let valorUtilizado = this.formatSumMoney(item.valorUtilizado)
                const saldo = this.formatSumMoney(cota) - valorUtilizado

                return this.formatMoney(parseFloat(saldo), 2)
            } else {

                const saldo = item.cota - Number(item.quantidadeUtilizada)

                return this.formatMoney(saldo, 0)
            }
        },
        getCotaAtribuida(item) {

            if (item.cotaTipoId == this.enums.tipoCota.VALOR) {

                return this.formatMoney((item.cotaAtribuida), 2)
            } else {

                return this.formatMoney(item.cotaAtribuida, 0)
            }
        },
        getCotaADistribuir(item) {

            if (item.cotaTipoId == this.enums.tipoCota.VALOR) {

                let cota = this.formatMoney(item.cota, 2)
                let cotasAtribuidas = this.formatMoney(item.cotaAtribuida, 2)

                let saldoAtribuidas = this.formatSumMoney(cota) - this.formatSumMoney(cotasAtribuidas)
                return this.formatMoney(saldoAtribuidas, 2)
            } else {

                let saldoAtribuidas = item.cota - Number(item.cotaAtribuida)
                saldoAtribuidas = this.formatMoney(saldoAtribuidas, 0)
                return this.formatMoney(saldoAtribuidas, 0)
            }
        },
        handleDestroy(item) {

            this.cotasAtribuidas = item.unidadeSolicitante.length + item.exames.length

            if (this.cotasAtribuidas > 0) {

                this.showValidationNotification(`Não é possível excluir a cota, pois já foi atribuída.`)

                return false
            }

            const objId = this.cotaLaboratorio.findIndex((obj => obj.cotaTipoId == item.cotaTipoId
                && obj.periodo.start == item.periodo.start));

            const destroy = async () => {
                this.cotaLaboratorio.splice(objId, 1)
                this.data.model.cotasLaboratorio.find(unidade => unidade.infraestruturaId == item.infraestruturaId).cotaLaboratorio = this.cotaLaboratorio
                this.data.model.cotasLaboratorio.find(unidade => unidade.infraestruturaId == item.infraestruturaId).alterado = true
                this.data.model.cotasLaboratorio.push()
            }

            this.showDeleteConfirmation(`Deseja realmente excluir a cota do laboratório?`,
                destroy)
        },
        handleClearFilter() {

            this.filter = null
            this.model.cotaMes = null
            this.model.cotaAno = null
        },
        openExame(index, item) {

           this.$refs.modalExame.open(index, item)
        },
        openUnidadeSolicitante(index, item) {

           this.$refs.modalUnidadeSolicitante.open(index, item)
        },
        save() {

            this.$emit('save')
        },
        getMes(value) {

            const data = moment(value, 'DD/MM/YYYY').month() + 1
            return this.enums.mesesAno[data]
        },
        getAno(value) {

            return moment(value, 'DD/MM/YYYY').year()
        },
        formatQuantidade(item) {

            const cota = item.cota
            return item.cotaTipoId == this.enums.tipoCota.VALOR ? cota : this.formatMoney(Number(cota), 0)
        },
    },
    mixins: [repository, data, formats],
    props: {
        cotaLaboratorio: { type: Array, required: true },
        data: { type: Object, required: true },
        cotaAno: { type: String, default: null },
        checkLaboratorio: { type: Boolean, required: true, default: false },
        unidadeId: { type: Number, default: null },
        infraestruturaId: { type: Number, default: null },
    },
    watch: {
        selectedColumns(value) {
            this.indeterminate = value.length > 0 && value.length != this.optionalColumns.length
            this.selectedAll = value.length > 0 && value.length == this.optionalColumns.length
        },
    }
}
</script>

<style scoped>
.popover{
    max-width: 70%;
}
.colorButton {
    color: #fff;
}
</style>